import React from 'react';
import { Card, CardHeader, Container,Box, CardContent } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import LogoImage from './LogoImage';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    backgroundColor: '#6179D3'
  },
  rootContainer: {
    justifyContent: 'center',
  },
  logoBox: {
    justifyContent: 'center',
    display:'flex',
    alignItems: 'center',
    width: '100%',
  },
  card: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5%',
    width: '100%',
    boxShadow: '-2px 0px 16px rgba(0, 0, 0, 0.25)',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 25, 0, 0),
    },
  },
  cardHeader: {
    fontWeight: 'bold',
    color: '#6179D3'
  },
  form: {
    maxWidth: theme.spacing(52),
    padding: theme.spacing(5),
    width: '100%',
  },
}));

const LoginLayout = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <main className={classes.root}>
      <Container maxWidth='xs' className={classes.rootContainer}>
        <Box className={classes.logoBox}>
          <LogoImage />
        </Box>
        
        <Card className={classes.card}>
          <CardHeader 
            className={classes.cardHeader}
            title="Bem vindo!"
            subheader="Faça login ao sistema"
          />
          <CardContent>
            <form className={classes.form}>
              {children}
            </form>
            </CardContent>
        </Card>
        </Container>
    </main>
  );
};

export default LoginLayout;
